import React, { useState } from "react";
import "./Filter.css";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getsizes } from "../../../network/api/sizes";
import * as brandapi from "../../../network/api/brand";
import axios from "axios";
import { link } from "../../../config";

function RateFilter({ setRate }) {
  const categories = [
    { id: 1, label: "1" },
    { id: 2, label: "2" },
    { id: 3, label: "3" },
    { id: 4, label: "4" },
    { id: 5, label: "5" },
  ];
  const [activeCategory, setActiveCategory] = useState(1);

  const handleCategoryClick = (category) => {
    if (activeCategory === category) {
      setActiveCategory(null)
      setRate(null)
      return;
    }
    setActiveCategory(category);
    setRate(category)
  };

  return (
    <div className="w-100">
      <div className="category-buttons-div">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`category-button ${activeCategory === category.id ? "actives" : "not-active"
              }`}
            onClick={() => handleCategoryClick(category.id)}
          >
            {category.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default RateFilter;

export function Sizefilter({ sizes }) {
  const itemsPerPage = 10;
  const [activeCategories, setActiveCategories] = useState([]);
  const [visibleCategories, setVisibleCategories] = useState(
    sizes.slice(0, itemsPerPage)
  );
  const [currentPage, setCurrentPage] = useState(1);

  const handleCategoryClick = (category) => {
    if (activeCategories.includes(category)) {
      setActiveCategories(activeCategories.filter((item) => item !== category));
    } else {
      setActiveCategories([...activeCategories, category]);
    }
  };

  const loadMoreCategories = () => {
    const nextPage = currentPage + 1;
    const endIndex = nextPage * itemsPerPage;
    setVisibleCategories(sizes.slice(0, endIndex));
    setCurrentPage(nextPage);
  };
  return (
    <div className=" w-100 ">
      <div className="category-buttons-div">
        {visibleCategories.map((category) => (
          <button
            key={category.size_name}
            className={`category-button ${activeCategories.includes(category.size_name)
              ? "active"
              : "not-active"
              }`}
            onClick={() => handleCategoryClick(category.size_name)}
          >
            {category.size_name}
          </button>
        ))}
      </div>
      <div className="load-more-button my-2">
        {visibleCategories.length < sizes.length && (
          <button onClick={loadMoreCategories}>Load More</button>
        )}
      </div>
    </div>
  );
}

export function PriceFilter({ maxPrice, setMaxPrice, minPrice, setMinPrice }) {
  const { t } = useTranslation();

  return (
    <div>
      <form className="  priceForm mx-4">
        <div className="price-inputs-div ">
          <input
            placeholder=" 9 "
            type="text"
            className=" bg-white priceinput "
            id="minPrice"
            value={minPrice}
            onChange={(event) => setMinPrice(event.target.value)}
            required
          />
          <span className="price-inputs-to"> {t("to")}</span>

          <input
            placeholder=" 345 "
            type="text"
            className=" bg-white priceinput "
            id="maxPrice"
            value={maxPrice}
            onChange={(event) => setMaxPrice(event.target.value)}
            required
          />
        </div>
        {minPrice && maxPrice ? (
          <button className=" pricebtn" type="submit">
            {t("go")}
          </button>
        ) : null}
      </form>
    </div>
  );
}

export function Brands({ brands, selectedbrands, setselectedbrands }) {
  const handleCheckboxChange = async (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setselectedbrands([...selectedbrands, value])
     
      // console.log(value);
      
      // try {
      //  const {data} = await axios.get(`${link}product/filter-brand/${value}`)
      //  console.log(data);
       
      // } catch (error) {
      //   console.log(error);
        
      // }
      
    } else {
      setselectedbrands(
        selectedbrands.filter((item) => item !== value)
      );
    }
  };

  return (
    <div className=" w-100 px-4">
      <div className="tair_l_div ">
        {brands.map((checkbox) => (
          <div
            className=" my-1   d-flex justify-content-between flex-wrap"
            key={checkbox.name}
          >
            <label
              className="w-100   d-flex justify-content-between flex-wrap"
              key={checkbox.name}
            >
              <div className=" d-flex">
                <div
                  className=" d-flex justify-content-left "
                  style={{ alignItems: "center" }}
                >
                  <input
                    style={{ display: "none" }}
                    type="checkbox"
                    id={checkbox.name}
                    value={checkbox._id}
                    checked={selectedbrands.includes(checkbox._id)}
                    onChange={handleCheckboxChange}
                  />
                  <label
                    className=" "
                    htmlFor={checkbox.name}
                    style={{ cursor: "pointer", marginRight: "10px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <rect
                        x="1"
                        y="1"
                        width="26"
                        height="26"
                        rx="7"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinejoin="round"
                      />
                      {selectedbrands.includes(checkbox._id) && (
                        <path
                          d="M4 12L11 19L24 6"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      )}
                    </svg>
                  </label>
                </div>
                <div className=" d-flex mx-2 " style={{ alignItems: "center" }}>
                  <p className="a_l_par" style={{ margin: "0px" }}>
                    {checkbox.name}
                  </p>
                </div>
              </div>

             
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Colors() {
  const [selectedCheckcol, setSelectedCheckcol] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedCheckcol([...selectedCheckcol, value]);
    } else {
      setSelectedCheckcol(selectedCheckcol.filter((item) => item !== value));
    }
  };

  const checkcol = [
    { hexacode: "col1", value: "#61AD92" },
    { hexacode: "col2", value: "000" },
    { hexacode: "col3", value: "fff" },
    { hexacode: "col4", value: "692b2b" },
    { hexacode: "col5", value: "61AD92" },
    { hexacode: "col6", value: "#1d4f40" },
    { hexacode: "col7", value: "592240" },
    { hexacode: "col8", value: "#1d2d4f" },
    { hexacode: "col9", value: "#425922" },
    { hexacode: "col10", value: "#b9df0d" },
    { hexacode: "col11", value: "df960d" },
    { hexacode: "col12", value: "0ddfbc" },
  ];

  return (
    <div className=" w-100">
      <div className="tair_l_div px-4">
        {checkcol.map((checkbox) => (
          // <div className=' my-1 bg-dark   d-flex justify-content-between flex-wrap' key={checkbox.value}>
          <label
            className="w-100 my-1   d-flex justify-content-between flex-wrap"
            key={checkbox.value}
          >
            <div className=" d-flex">
              <div
                className=" d-flex justify-content-left "
                style={{ alignItems: "center" }}
              >
                <input
                  style={{ display: "none" }}
                  type="checkbox"
                  id={checkbox.value}
                  value={checkbox.value}
                  checked={selectedCheckcol.includes(checkbox.value)}
                  onChange={handleCheckboxChange}
                />
                <label
                  className=" "
                  htmlFor={checkbox.value}
                  style={{ cursor: "pointer", marginRight: "10px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <rect
                      x="1"
                      y="1"
                      width="26"
                      height="26"
                      rx="7"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinejoin="round"
                    />
                    {selectedCheckcol.includes(checkbox.value) && (
                      <path
                        d="M4 12L11 19L24 6"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    )}
                  </svg>
                </label>
              </div>
              <div className=" d-flex mx-2 " style={{ alignItems: "center" }}>
                <i
                  style={{
                    background: `#${checkbox.value.replace("#", "")}`,
                    color: `#${checkbox.value.replace("#", "")}`,
                    width: "1rem",
                    height: "1rem",
                    borderRadius: "1rem",
                    border: "0.1px gray solid",
                  }}
                ></i>
                <p className="a_l_par mx-1" style={{ margin: "0px" }}>
                  {checkbox.hexacode}
                </p>
              </div>
            </div>

            
          </label>
        ))}
      </div>
    </div>
  );
}

export function Newest({ setBeforeDays }) {
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);

  const handleCheckboxChange = (value) => {
    setSelectedCheckbox(value);
    setBeforeDays(value)
  };
  const handleCheckboxClick = (value) => {

    if (selectedCheckbox == value) {
      setSelectedCheckbox(null)
      setBeforeDays(null)
      return;
    }
  };

  const checkboxes = [
    { label: 1, value: "اخر 7 يوم", beforeDays: 7 },
    { label: 2, value: "اخر 30 يوم", beforeDays: 30 },
    { label: 3, value: "اخر 60 يوم", beforeDays: 60 },
    { label: 4, value: "اخر 120 يوم", beforeDays: 120 },
  ];

  return (
    <div className=" w-100 px-4">
      <div className="tair_l_div">
        {checkboxes.map((checkbox) => (
          <label
            className="w-100 d-flex justify-content-between flex-wrap"
            key={checkbox.value}
          >
            <div className="d-flex">
              <div
                className="d-flex justify-content-left"
                style={{ alignItems: "center" }}
              >
                <input
                  style={{ display: "none", border: "2px solid black" }}
                  type="radio"
                  id={checkbox.value}
                  value={checkbox.value}
                  checked={selectedCheckbox === checkbox.beforeDays}
                  onClick={() => handleCheckboxClick(checkbox.beforeDays)}
                  onChange={() => handleCheckboxChange(checkbox.beforeDays)}
                />
                <label
                  className=""
                  htmlFor={checkbox.value}
                  style={{ cursor: "pointer", marginRight: "10px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <circle
                      cx="14"
                      cy="14"
                      r="13"
                      stroke="#D99D2B"
                      strokeWidth="2"
                      fill={
                        selectedCheckbox === checkbox.beforeDays ? "#D99D2B" : "none"
                      }
                      strokeLinejoin="round"
                    />
                    {selectedCheckbox === checkbox.beforeDays && (
                      <circle cx="14" cy="14" r="5" fill="white" />
                    )}
                  </svg>
                </label>
              </div>
              <div className="d-flex mx-2" style={{ alignItems: "center" }}>
                <p className="a_l_par" style={{ margin: "0px" }}>
                  {checkbox.value}
                </p>
              </div>
            </div>
            
          </label>
        ))}
      </div>
    </div>
  );
}

export function Sale({ setSale }) {
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);

  const handleCheckboxChange = (value) => {
    setSelectedCheckbox(value);
    setSale(value)
  };


  const handleCheckboxClick = (value) => {

    if (selectedCheckbox == value) {
      setSelectedCheckbox(null)
      setSale(null)
      return;
    }
  };

  const checkboxes = [
    { label: 1, value: "20%" },
    { label: 2, value: "30%" },
    { label: 3, value: "50%" },
    { label: 4, value: "70%" },
  ];

  return (
    <div className=" w-100 px-4 ">
      <div className="tair_l_div">
        {checkboxes.map((checkbox) => (
          <label
            className="w-100 d-flex justify-content-between flex-wrap"
            key={checkbox.value}
          >
            <div className="d-flex">
              <div
                className="d-flex justify-content-left"
                style={{ alignItems: "center" }}
              >
                <input
                  style={{ border: "2px solid black", display: "none" }}
                  type="radio"
                  id={checkbox.value}
                  value={checkbox.value}
                  checked={selectedCheckbox === checkbox.value}
                  onClick={() => handleCheckboxClick(checkbox.value)}
                  onChange={() => handleCheckboxChange(checkbox.value)}
                />
                <label
                  className=""
                  htmlFor={checkbox.value}
                  style={{ cursor: "pointer", marginRight: "10px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <circle
                      cx="14"
                      cy="14"
                      r="13"
                      stroke="#D99D2B"
                      strokeWidth="2"
                      fill={
                        selectedCheckbox === checkbox.value ? "#D99D2B" : "none"
                      }
                      strokeLinejoin="round"
                    />
                    {selectedCheckbox === checkbox.value && (
                      <circle cx="14" cy="14" r="5" fill="white" />
                    )}
                  </svg>
                </label>
              </div>
              <div className="d-flex mx-2" style={{ alignItems: "center" }}>
                <p className="a_l_par" style={{ margin: "0px" }}>
                  {checkbox.value}
                </p>
              </div>
            </div>
            
          </label>
        ))}
      </div>
    </div>
  );
}

export function FilterSide({
  id,
  page,
  maxPrice,
  setMaxPrice,
  minPrice,
  setMinPrice,
  selectedcolors,
  setselectedcolors,
  selectedbrands,
  setselectedbrands,
  setSale,
  sale,
  setBeforeDays,
  setRate,
  showfilter,
  setShowFilter,
  subCategoryData
}) {
  const [ShowSale, setShowSale] = useState(false);
  const [ShowNewest, setShowNewest] = useState(false);
  const [ShowColors, setShowColors] = useState(false);
  const [ShowBrands, setShowBrands] = useState(false);
  const [ShowPriceFilter, setShowPriceFilter] = useState(false);
  const [ShowSizefilter, setShowSizefilter] = useState(false);
  const [ShowRateFilter, setShowRateFilter] = useState(false);

  const handleSaleClick = () => {
    setShowSale(!ShowSale);
  };

  const handleNewestClick = () => {
    setShowNewest(!ShowNewest);
  };
  const handleColorsClick = () => {
    setShowColors(!ShowColors);
  };
  const handleBrandsClick = () => {
    setShowBrands(!ShowBrands);
  };
  const handlePriceFilterClick = () => {
    setShowPriceFilter(!ShowPriceFilter);
  };
  const handleSizefilterClick = () => {
    setShowSizefilter(!ShowSizefilter);
  };
  const handleRateFilterClick = () => {
    setShowRateFilter(!ShowRateFilter);
  };
  const [sizes, setSizes] = useState([]);
  const [brands, setbrands] = useState([]);

  useEffect(() => {
    getsizes(id).then((result) => {
      setSizes(result.data.response);
    });
    // brandapi.bySubCategory(id).then((result) => {
    //   setbrands(result.data.response);
    // });
    const getBrands = async () => {
      try {
        const {data} = await axios.get(`${link}brands/products`);
        setbrands(data.brands)
  
        
      } catch (error) {
        console.log(error);
        
      }
    }
    getBrands()
  }, []);

  const { t, i18n } = useTranslation();
  return (
    <div>
      <div className="path px-5 d-flex align-items-center gap-2 mb-2 ">
        <span>الرئيسيه</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5781 3.4001L7.14479 8.83343C6.50312 9.4751 6.50312 10.5251 7.14479 11.1668L12.5781 16.6001" stroke="#807D7E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{i18n.language == "en" ? subCategoryData?.category?.name : subCategoryData?.category?.nameAr}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5781 3.4001L7.14479 8.83343C6.50312 9.4751 6.50312 10.5251 7.14479 11.1668L12.5781 16.6001" stroke="#807D7E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{i18n.language == "en" ? subCategoryData?.name : subCategoryData?.nameAr}</span>
      </div>
      <div className={`filterside-div pt-2 ${!showfilter ? 'd-none d-lg-block ' : ''}`}>
        <div className="filter_type_h mx-4 mb-2">{t("filterwith")} </div>
        <div className="max-filter">
          <div className="filters-div w-100">
            <div
              className="d-flex justify-content-between  w-100 px-3"
              role="button"
              onClick={handlePriceFilterClick}
            >
              <span className="filter_type">{t("price")}</span>
              {!ShowPriceFilter ? (
                <span className="filtersign">+</span>
              ) : (
                <span className="filtersign">-</span>
              )}
            </div>
            {ShowPriceFilter && (
              <PriceFilter
                maxPrice={maxPrice}
                setMaxPrice={setMaxPrice}
                minPrice={minPrice}
                setMinPrice={setMinPrice}
              ></PriceFilter>
            )}
            <div className="filterline"></div>
            <div
              className="d-flex justify-content-between w-100 px-3"
              role="button"
              onClick={handleBrandsClick}
            >
              <span className="filter_type">{t("brand")}</span>
              {!ShowBrands ? (
                <span className="filtersign">+</span>
              ) : (
                <span className="filtersign">-</span>
              )}
            </div>
            {ShowBrands && <Brands brands={brands} selectedbrands={selectedbrands} setselectedbrands={setselectedbrands}></Brands>}
            <div className="filterline"></div>
            <div className="d-flex justify-content-between  w-100 px-3"
              role="button" onClick={handleSaleClick}
            >
              <span className="filter_type">{t("sale")}</span>
              {!ShowSale ? (
                <span className="filtersign">+</span>
              ) : (
                <span className="filtersign">-</span>
              )}
            </div>
            {ShowSale && <Sale setSale={setSale} sale={sale}></Sale>}
            <div className="filterline"></div>
            <div className="d-flex justify-content-between w-100 px-3"
              role="button" onClick={handleNewestClick}
            >
              <span className="filter_type">{t("new")}</span>
              {!ShowNewest ? (
                <span className="filtersign">+</span>
              ) : (
                <span className="filtersign">-</span>
              )}
            </div>
            {ShowNewest && <Newest setBeforeDays={setBeforeDays}></Newest>}
            <div className="filterline"></div>
            <div
              className="d-flex justify-content-between w-100 px-3"
              role="button"
              onClick={handleColorsClick}
            >
              {/* <span className="filter_type">{t("color")}</span> */}
              {/* {!ShowColors ? (
              <span className="filtersign">+</span>
              ) : (
                <span className="filtersign">-</span>
          )} */}
            </div>
            {/* {ShowColors && <Colors></Colors>} */}
            {/* <div className="filterline"></div> */}
            {/* <div
          className="d-flex justify-content-between  w-100 px-3"
          role="button"
          onClick={handleSizefilterClick}
        >
          <span className="filter_type">{t("size")}</span>
          {!ShowSizefilter ? (
            <span className="filtersign">+</span>
            ) : (
              <span className="filtersign">-</span>
              )}
            </div> */}
            {ShowSizefilter && <Sizefilter sizes={sizes}></Sizefilter>}
            {/* <div className="filterline"></div> */}
            {/* <div className="d-flex justify-content-between w-100 px-3 pb-0 mt-0"
              role="button" onClick={handleRateFilterClick}
            >
              <span className="filter_type">{t("rate")}</span>
              {!ShowRateFilter ? (
                <span className="filtersign">+</span>
              ) : (
                <span className="filtersign">-</span>
              )}
            </div>
            {ShowRateFilter && <RateFilter setRate={setRate}></RateFilter>} */}
          </div>
        </div>
        <div className="w-100 d-flex justify-content-center mb-2 mt-4 d-lg-none ">
          <button onClick={() => setShowFilter(false)}
            className=" text-white rounded-2 " style={{ background: '#D99D2B', padding: '5px 40px', border: 'none' }}>تطبيق</button>
        </div>
      </div>
    </div>
  );
}
